import React from "react";
import TermsList from "../components/TermsList";
import { TermsDocId } from "../types/terms";

const PrivacyPolicy: React.FC = () => {
  return (
    <TermsList id={TermsDocId.PRIVACY_POLICY} title="Política de Privacidade" />
  );
};

export default PrivacyPolicy;
